import { memo } from 'react'

import { Skeleton, SkeletonVariants } from '@inno-ui/skeleton'

import styles from './PreviewSkeleton.module.scss'

export const PreviewSkeleton = memo(() => {
  return (
    <div className={styles.previewSkeleton}>
      <Skeleton
        variant={SkeletonVariants.Rectangular}
        height={450}
        width={350}
      />
      <div className={styles.infoSkeleton}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            variant={SkeletonVariants.Rectangular}
            height={30}
            width={350}
          />
        ))}
      </div>
    </div>
  )
})
